@if (editMode) {
  <div>
  </div>
}
@if (!editMode) {
  <div>
    <div class="attachments">
      {{ controlDisplay }}
    </div>
  </div>
}
